import { BUTTON_RADIUS } from './ui-constants.js';
// Shared modern geometry. Theme and text size are independent preferences.
export const deliveredDesign = layout => layout === "modern2" || layout === "accessible";
export function deliveredPalette(base, layout, dark) {
  // Keep these legacy function arguments for older API clients. Colour no longer
  // selects geometry: the single layout uses the old modern dark / cream light palette.
  const colors = dark
    ? {canvas:"#080C1D",surface:"#111831",surfaceSoft:"#202A4B",ink:"#F6F8FF",muted:"#AAB4D2",line:"#2B365D",primary:"#68E4D2",primaryText:"#071A19",primarySoft:"#202A4B",ok:"#72E6A5",okSoft:"#153B31",attention:"#FFCF66",attentionSoft:"#3C321F",critical:"#FF7A90",criticalSoft:"#422039",map:"#233054",road:"#7887AF"}
    : {canvas:"#F6F1E7",surface:"#FFFFFF",surfaceSoft:"#E8EEF4",ink:"#122437",muted:"#526273",line:"#CDD6DE",primary:"#1F5D8F",primaryText:"#FFFFFF",primarySoft:"#E8EEF4",ok:"#247A4A",okSoft:"#E5F3EA",attention:"#A75B00",attentionSoft:"#FFF1D7",critical:"#B3263E",criticalSoft:"#FCE9ED",map:"#DDE9D9",road:"#96A59C"};
  return {...base,...colors};
}
export function deliveredStyles(sheet, layout) {
 const result = {};
 for(const [name,original] of Object.entries(sheet)) {
  const s={...original};
  if(typeof s.fontSize === "number") {
   s.fontSize=Math.max(15,s.fontSize);
   if(/title|heading/i.test(name)) {s.fontSize=Math.max(20,s.fontSize);s.fontWeight="800";}
   if(/value|metricValue/.test(name)) {s.fontSize=Math.max(26,s.fontSize);s.fontWeight="800";}
   s.lineHeight=Math.max(s.lineHeight??0,Math.ceil(s.fontSize*(1.4)));
  }
  if(typeof s.borderRadius === "number" && s.borderRadius>6) s.borderRadius=16;
  if(/^(card|settingsCard|infoPanel|inset|featureSheet)$/.test(name)) {
   s.borderRadius=24;
   if(s.padding!==undefined)s.padding=16;
   if(s.gap!==undefined)s.gap=16;
   s.shadowColor="#000";s.shadowOpacity=.22;s.shadowRadius=14;s.shadowOffset={width:0,height:8};s.elevation=4;
  }
  if(/button|choice|segment|textField|input|field|controlRow/i.test(name) && !/Text|Label|Symbol|Selected|Group|Wrap/i.test(name)) {
   s.minHeight=Math.max(s.minHeight??0,48);
   if(s.borderRadius!==undefined)s.borderRadius=24;
  }
  if(/button|choice|segment|cancel|navItem/i.test(name) && !/Text|Label|Symbol|Selected|Group|Wrap/i.test(name)) s.borderRadius=BUTTON_RADIUS;
  if(/button|choice|segment|cancel/i.test(name) && !/Text|Label|Symbol|Selected|Group|Wrap/i.test(name)) {s.alignItems='center';s.justifyContent='center';s.alignSelf='stretch';s.minWidth=0;}
  if(/(button|choice|segment|cancel).*(Text|Label)$/i.test(name)) s.textAlign='center';
  if(/^(metric|quickCard)$/.test(name)) {s.flexBasis="45%";s.minWidth=0;s.flexGrow=1;s.flexShrink=1;s.minHeight=108;s.padding=16;s.borderRadius=16;}
  if(/featureRow|settingRow/.test(name)) {s.minHeight=60;s.paddingVertical=12;}
  if(name==="featureSummary") {s.fontSize=15;s.lineHeight=21;}
  if(name==="scrollContent") {s.paddingHorizontal=16;s.gap=16;s.paddingBottom=24;}
  if(name==="header") {s.paddingHorizontal=16;s.paddingVertical=16;s.gap=12;}
  if(name==="identity") {s.flex=1;s.minWidth=0;}
  if(name==="personName") {s.fontSize=20;s.lineHeight=27;s.fontWeight="800";}
  if(name==="avatar") {s.width=48;s.height=48;s.borderRadius=999;}
  if(name==="bottomNav") {s.flexDirection="column";s.flexShrink=0;s.minHeight=72;s.marginHorizontal=12;s.marginBottom=8;s.padding=8;s.paddingTop=8;s.paddingBottom=8;s.borderRadius=24;s.borderWidth=1;s.borderTopWidth=1;s.shadowOpacity=.18;s.shadowRadius=12;s.elevation=8;}
  if(name==="navItem") {s.flex=1;s.flexBasis=0;s.minWidth=0;s.minHeight=52;s.gap=4;s.borderRadius=12;}
  if(name==="navLabel") {s.fontSize=10;s.lineHeight=14;s.fontWeight="800";}
  if(name==="alarmBadgeText") {s.fontSize=10;s.lineHeight=13;}
  if(name==="toast") s.bottom=104;
  result[name]=s;
 }
 return result;
}
